import { Box, Typography, Button } from "@mui/material";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppContext } from "../context/AppContext";
import Login from "./Login";
import MenuBar from "../components/layout/MenuBar";

const Home = () => {
    const [openLogin, setOpenLogin] = useState(false);
    const [cameFromUnauthorized, setCameFromUnauthorized] = useState(false);

    const location = useLocation();
    const navigate = useNavigate();
    const { user } = useAppContext();
    const isLoggedIn = !!user;

    const handleCloseLogin = () => setOpenLogin(false);

    const handleOpenLogin = () => {
        if (cameFromUnauthorized) {
            navigate("/unauthorized");
            return;
        }
        setOpenLogin(true);
    };

    useEffect(() => {
        if (location?.state?.fromUnauthorized) {
            setCameFromUnauthorized(true);
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [location, navigate]);

    return (
       <Box
  sx={{
    display: "flex",
    minHeight: "90vh",
  }}
>

            {isLoggedIn && (
                <Box
                    sx={{
                        width: { xs: "auto", md: "25%" },
                        mt: 4,
                    }}
                >
                    <MenuBar />
                </Box>
            )}

            <Box
                sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    width: "100%",
                    minHeight: "calc(100vh - 100px)",
                    px: { xs: 2, md: 0 },
                }}>
                {isLoggedIn ? (
                    <Box>
                        <Typography
                            sx={{
                                fontWeight: 900,
                                fontSize: { xs: "2.5rem", md: "6rem" },
                                background: "linear-gradient(45deg, orange, green)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                            }}
                        >
                            Welcome
                        </Typography>

                        <Typography
                            sx={{
                                fontWeight: 700,
                                fontSize: { xs: "1.8rem", md: "4rem" },
                                background: "linear-gradient(45deg, green, orange)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                            }}
                        >
                            To Reward Application..
                        </Typography>
                    </Box>
                ) : (
                    <>
                        <Box
                            sx={{
                                width: { xs: 140, md: 200 },
                                height: { xs: 140, md: 200 },
                                borderRadius: "50%",
                                backgroundColor: "rgba(255,144,22,0.12)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                mb: 2,
                            }}
                        >
                            <LockOpenIcon
                                sx={{ fontSize: { xs: 30, md: 60 }, color: "#ff8c00" }}
                            />
                        </Box>

                        <Typography
                            sx={{
                                mb: 3,
                                fontWeight: 800,
                                fontSize: { xs: "1.5rem", md: "3rem" },
                                background: "linear-gradient(45deg, green, orange)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                            }}
                        >
                            Please login to access the application...
                        </Typography>

                        <Button
                            variant="contained"
                            onClick={handleOpenLogin}
                            sx={{ fontSize: "1rem", px: 4 }}
                        >
                            LOGIN
                        </Button>

                        <Login open={openLogin} onClose={handleCloseLogin} />
                    </>
                )}
            </Box>
        </Box>
    );
};

export default Home;